export default __webpack_public_path__ + "static/logo-cp-white-web-a4d3aa6000599d0210cd673f39c8f311.png";